<template>
  <div id="instrument-operation">
    <common-search :searchList="searchList" @onSearch="onSearch" type="coupon"></common-search>

    <common-table
      :product_list="coupon_list"
      :loading="loading"
      @sort-change="sortChange"
      @data-change="getMessageByPage"
      storageName="checkedHeaders_coupon"
      title="万森文创优惠券生成表"
      type="coupon"
      height="650"
      :newCheckHeader="checkedHeaders"
      ></common-table>

    <div style="text-align: right;margin-top:10px">
       <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="pageSizes"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import EquipmentTableComponent from "@/components/instrument/EquipmentTableComponent.vue";
import SearchComponent from "@/components/instrument/SearchComponent.vue";
export default {
  name: 'instrument-operation',
  components: {
    'common-table': EquipmentTableComponent,
    'common-search': SearchComponent
  },
  data() {
    return {
      loading: false,
      coupon_list: null,
      searchList: {
        couponName: '',
      },
      tableHandler: [],
      currentPage: 1,
      total: 0,
      pageSizes: [10, 20, 50],
      pageSize: 20,
      uploading: '',
      checkedHeaders: ['优惠券名称', '优惠金额','使用条件','有效天数'],
    }
  },
  async mounted(){
    this.getMessageByPage();
  },
  watch: {
  },
  methods: {
    async getMessageByPage(){
      this.loading = true;

      let borrowType = 'admin_now';

      let options = this.$util.formatOptions(this.searchList);

      if(this.$util.isEmpty(this.order))
        this.order = "default";

      const coupon_list = await this.$request.get_message('coupons',{page: this.currentPage,limit: this.pageSize,query: options});

      this.coupon_list = coupon_list.data;
      this.total = coupon_list.total
      this.loading = false;
    },

    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.getMessageByPage();
    },
    handleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getMessageByPage();
    },

    sortChange(val){
      this.order = val.order;
      this.getMessageByPage();
    },

    onSearch(){
      this.$commondata.searchObj = this.searchList;
      this.getMessageByPage();
    }
  }
}
</script>
<style>
html,body{
  margin: 0;
  height: 100%;
}
#instrument-operation{
  position: relative;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/instrument/Coupon.vue